import React from "react";
import MarinaFacility from "components/comp/MarinaFacility";
import SubPicture from "components/comp/SubPicture";
import yacht3 from "assets/images/yacht3.jpg"

//마리나시설
const DetailService = () => {
  return (
    <main className="company page-main company-more-wrap">
      <section className="company-main">
        <SubPicture img={yacht3}/>
        <MarinaFacility/>
      </section>
    </main>
  );
};

export default DetailService;
